import * as React from 'react'

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormLabel from '@mui/material/FormLabel'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Divider from '@mui/material/Divider'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete'
import Chip from '@mui/material/Chip'
import List from '@mui/material/List'
import ListItemIcon from '@mui/material/ListItemIcon'
import ExpandCircleDownOutlinedIcon from '@mui/icons-material/ExpandCircleDownOutlined'
import ArrowDropDownCircleOutlinedIcon from '@mui/icons-material/ArrowDropDownCircleOutlined'
import ListItem, { ListItemProps } from '@mui/material/ListItem'

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { styled } from '@mui/material/styles'

import Plus from 'mdi-material-ui/Plus'
import ContentSave from 'mdi-material-ui/ContentSave'
import TextField from '@mui/material/TextField'
import FileDocumentOutline from 'mdi-material-ui/FileDocumentOutline'

import dayjs from 'dayjs'
import Icon from '@/@core/components/icon'
import {
  Backdrop,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormHelperText,
  IconButton,
  InputBase,
  ListItemText,
  Paper,
  Slide,
  Stack,
  Switch,
  Tooltip
} from '@mui/material'

import { useForm, Controller } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { useTranslation } from 'react-i18next'
import ChinahpoSearch from '@/@core/components/chinahpo-search'
import { Close, ContentCopy, PlusCircleOutline, Pulse } from 'mdi-material-ui'
import { useRouter } from 'next/router'
import {
  editPatients,
  editSample,
  fetchPatientBySampleId,
  fetchSampleById,
  GetTermsByClinicalInfoDto,
  Patients,
  Sample,
  translate,
  translates,
  getTermByClinicalInfo,
  TranslateBulkDto,
  TranslateDto,
  fetchAnalyzeInfoByAnalysisId,
  GeneSets,
  getGeneSets,
  fetchProjects,
  Project,
  assumeRole,
  createProject,
  createGeneSets,
  editGeneSets,
  Analysis,
  editAnalysis,
  updataAnalyzeSample,
  createPatientsFiles,
  editPatientsFiles,
  deletePatientsFiles,
  getPatientsFiles,
  PatientsFile,
  ChatClaudeDto,
  chatDeepSeek,
  chatQwenApp,
  getHpoTerms,
  phenotypeExtract
} from '@/@core/services/app.service'
import SearchIcon from '@mui/icons-material/Search'
import DirectionsIcon from '@mui/icons-material/Directions'
import { useMutation, useQuery } from 'react-query'
import CloseIcon from '@mui/icons-material/Close'
import {
  calculateBirthDate,
  containsChinese,
  deduplicateArrays,
  demo,
  formatDate,
  getArr,
  groupObjectBySize,
  isJson,
  isValidURL,
  unique
} from '@/@core/utils/utils'
import PositionedSnackbar from '@/@core/components/message'
import PasteHtmlExample from '@/@core/components/braft/react-slate'
import axios, { AxiosRequestConfig } from 'axios'
import OSS from 'ali-oss'
import { LinearProgressWithLabel } from '@/pages/samples/SampleTabs/UpBamFile'
import RolDialog from '@/views/setting/DialogRol'
import { useDropzone } from 'react-dropzone'
import { TransitionProps } from '@mui/material/transitions'
import { message } from 'antd'
import { copyToClipboard } from '@/@core/layouts/utils'

// ** Styled Components
const ListItemStyled = styled(ListItem)<
  ListItemProps & { component?: React.ElementType }
>(({ theme }) => ({
  borderLeftWidth: '3px',
  borderLeftStyle: 'solid',
  padding: theme.spacing(0, 5),
  marginBottom: theme.spacing(1)
}))

interface FilmOptionType {
  inputValue?: string
  id?: number
  name: string
}

export interface Patient {
  patientId: string
  patientName: string
  infirmaryName: string | null
  departmentName: string | null
  caseNumber: string | null
  sampleCode: string

  // lastName: string
  dateOfBirth: string
  gender: 'male' | 'female' | 'unknown'
  race: string
  geneSet: string | null
  sampleType: string
  receiveDate: dayjs.Dayjs
  resultsIn: string
  collectDate: string
  project: number
  physicianName: string
  familyHistory: string
  phenotype: string
  isAffect: boolean
  isProBand: boolean
  id: number | string
}
const SectionHeader = styled(Typography)(({ theme }) => ({
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  fontSize: 15,
  fontWeight: 700,
  lineHeight: 1.4,
  letterSpacing: '0.02em',
  color: theme.palette.text.primary,
  paddingLeft: theme.spacing(2),
  marginBottom: theme.spacing(1),
  '&::before': {
    content: '""',
    position: 'absolute',
    left: 0,
    top: '50%',
    width: 4,
    height: '1.25rem',
    transform: 'translateY(-50%)',
    borderRadius: 2,
    backgroundColor: theme.palette.primary.main
  }
}))

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    maxWidth: 'none'
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}))

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="down" ref={ref} {...props} />
})

const filter = createFilterOptions<FilmOptionType>()

const ChinahpoListSearch = React.forwardRef((props, ref) => {
  return (
    <Paper
      component="form"
      sx={{
        p: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: '100%'
      }}
    >
      <InputBase
        sx={{ ml: 1, flex: 1 }}
        placeholder="Search Google Maps"
        inputProps={{ 'aria-label': 'search terms list' }}
      />

      <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
        <SearchIcon />
      </IconButton>
    </Paper>
  )
})

const schema = yup.object().shape({
  // patientId: yup.string().required(),
  // patientName: yup.string().required(),
  // lastName: yup.string().required(),
  // dateOfBirth: yup.string().required(),
  // gender: yup.string().required(),
  // race: yup.string().required(),
  // sampleType: yup.string().required(),
  // receiveDate: yup.string().required(),
  // collectDate: yup.string().required(),
  // project: yup.string().required(),
  // physicianName: yup.string().required()
})

const PatientInformation = React.forwardRef(
  (
    props: {
      analysisInfo: any
      termList: any[]
      samples: Sample
      clinicalInformation: string
      analysisData?: any
      refetchAnalyzeInfo?: any
    },
    ref
  ) => {
    React.useImperativeHandle(ref, () => {
      return {}
    })
    const { t, i18n } = useTranslation()
    const [messageApi, contextHolder] = message.useMessage()
    const [reportList] = React.useState([
      {
        name: 'wqddddddddddddddddddddddddddddddddd'
      }
    ])
    const [clinicalInformation, setClinicalInformation] =
      React.useState<string>(props.clinicalInformation)
    const messageRef = React.useRef<any>()
    const [openRol, setOpenRol] = React.useState<boolean>(false)

    const [termList, setTermList] = React.useState<any[]>(props.termList)
    const [race, setRace] = React.useState('EastAsia')
    const [sampleType, setSampleType] = React.useState('')
    const [ChatQwen, setChatQwen] = React.useState<any[]>([])
    const [value, setValues] = React.useState<FilmOptionType | null>(null)

    const [backop, setBackop] = React.useState(false)
    const [key, setKey] = React.useState(0)
    const [abortCheckpoint, setAbortCheckpoint] = React.useState<any[]>([])
    const [client, setClient] = React.useState<OSS>()
    const [retryCount, setRetryCount] = React.useState(0)
    const retryCountMax = 1
    const [sampleField, setSampleField] = React.useState({
      patient: {
        fqFiles: [] as {
          fileName: string
          process: number
        }[],
        hasSv: false,
        svFile: '',
        svName: '',
        hasCnv: false,
        cnvFile: '',
        cnvKitFile: '',
        cnvName: ''
      }
    })

    const [cnvProcess, setCnvProcess] = React.useState<number>(0)
    const [svProcess, setSvProcess] = React.useState<number>(0)
    const [fqProcess, setFqProcess] = React.useState<number>(0)
    const [samples, setSamples] = React.useState<null | Sample>(props.samples)
    const [imgSrc, setImgSrc] = React.useState({
      src: '',
      name: '',
      id: 0
    })
    const [imgOpen, setImgOpen] = React.useState(false)
    const defaultValues = {
      patientId: '',
      sampleId: '',
      patientName: '',
      infirmaryName: '',
      sampleCode: '',
      departmentName: '',
      caseNumber: '',
      dateOfBirth: '',
      gender: 'male' as 'male' | 'female' | 'unknown',
      race: '',
      sampleType: '',
      geneSet: '',
      primerBedId: '',
      receiveDate: dayjs(new Date()),
      resultsIn: '',
      collectDate: '',
      BirthData: '',
      project: props.samples && (props.samples.projectId as number),
      physicianName: '',
      familyHistory: '',
      phenotype: '',
      id: '',
      isAffect: false,
      isProBand: false
    }

    // ** Hooks
    const { getRootProps, getInputProps } = useDropzone({
      onDrop: (acceptedFiles: File[]) => {
        if (acceptedFiles.length) {
          const file = acceptedFiles[0]

          if (file) {
            const reader = new FileReader()

            reader.onload = (e: any) => {
              setImgSrc({
                src: e.target.result,
                name: file.name,
                id: 0
              })

              if (samples?.patients && samples?.patients[0]) {
                const patientFileParams: PatientsFile = {
                  patientId: samples?.patients[0].id as any,
                  metadata: JSON.stringify({
                    imgSrc: e.target.result,
                    imgName: file.name
                  }),
                  createdAt: new Date()
                }

                createPatientsFileMutation.mutateAsync(patientFileParams)
              }
            }

            reader.onerror = (error) => {
              console.error('Error reading file:', error)
            }

            reader.readAsDataURL(file) // 读取文件为 Data URL (Base64)
          }
        }
      }
    })

    const router = useRouter()

    const { id } = router.query

    const type = router.asPath.includes('/samples') ? 'sample' : 'analyze'

    // if (type === 'sample') {
    //   // eslint-disable-next-line react-hooks/rules-of-hooks
    //   const { data: sampleByid } = useQuery<Sample>(
    //     ['sampleById'],
    //     async () => await fetchSampleById(id),
    //     {
    //       keepPreviousData: true,
    //       onSuccess: (sample) => {
    //         setClinicalInformation(sample.clinicalInformation as string)

    //         if (sample.terms && isJson(sample.terms as string)) {
    //           setTermList(JSON.parse(sample.terms as string))
    //         } else if (sample.terms && Array.isArray(sample.terms)) {
    //           setTermList(sample.terms)
    //         } else {
    //           setTermList([])
    //         }

    //         setSamples(sample)

    //         patientSample.mutateAsync(sample.id as number)
    //       }
    //     }
    //   )
    // } else {
    //   //analyze
    //   // eslint-disable-next-line react-hooks/rules-of-hooks
    //   const { data: analysis } = useQuery({
    //     queryKey: ['analyzeInfoByAnalysisId', id],
    //     queryFn: () => fetchAnalyzeInfoByAnalysisId(id),
    //     keepPreviousData: true,
    //     onSuccess: (data: any) => {
    //       if (data && data.affectedChild) {
    //         const sample = data.affectedChild

    //         setClinicalInformation(sample.clinicalInformation as string)

    //         if (sample.terms && isJson(sample.terms as string)) {
    //           setTermList(JSON.parse(sample.terms as string))
    //         } else if (sample.terms && Array.isArray(sample.terms)) {
    //           setTermList(sample.terms)
    //         } else {
    //           setTermList([])
    //         }

    //         setSamples(sample)

    //         patientSample.mutateAsync(sample.id)
    //       }
    //     }
    //   })
    // }

    React.useEffect(() => {
      if (samples && samples.id) {
        patientSample.mutateAsync(samples.id as number)
      }
    }, [samples])

    React.useEffect(() => {
      //
    }, [i18n.language])

    const handleSvUpload = async (file: File) => {
      if (file) {
        const formData = new FormData()

        formData.append('file', file)

        const config: AxiosRequestConfig = {
          onUploadProgress: (progressEvent: any) => {
            const progress = Math.round(
              (progressEvent.loaded / progressEvent.total) * 100
            )

            setSvProcess(progress)
          }
        }

        try {
          const { data } = await axios.post(
            '/api/oss/upload/',
            formData,
            config
          )

          if (data) {
            const value = {
              patient: {
                ...sampleField.patient,
                svName: file.name,
                svFile: file.name,
                hasSv: true
              }
            }

            setSampleField(value)
            const params = {
              ...samples,
              hasSv: 1,
              svFile: decodeURI(value.patient.svFile),
              terms: isJson(samples?.terms as string)
                ? samples?.terms
                : JSON.stringify(samples?.terms)

              // status:
              //   samples?.status === 'imported'
              //     ? 'vcf_annotated'
              //     : samples?.status
            }

            editSamples.mutateAsync(params as any)

            messageRef?.current?.handleClick(t('Upload successful'), 'success')
          }
        } catch (error) {
          messageRef?.current?.handleClick(
            t('Upload failed') + String(error),
            'error'
          )

          console.error('Upload error:', error)
        }
      }
    }

    const handleSvFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target.files && event.target.files.length > 0) {
        handleSvUpload(event.target.files[0])
      }
    }

    const handleFqUpload = async (file: File) => {
      if (file) {
        const formData = new FormData()

        formData.append('file', file)

        const config: AxiosRequestConfig = {
          onUploadProgress: (progressEvent: any) => {
            const progress = Math.round(
              (progressEvent.loaded / progressEvent.total) * 100
            )

            setFqProcess(progress)
          }
        }

        const fqFiles = sampleField.patient.fqFiles
        const flag = fqFiles.some((items) => items.fileName === file.name)
        if (flag)
          return messageRef?.current?.handleClick(
            t('The document is being uploaded. Please wait a moment'),
            'warning'
          )

        fqFiles.push({
          fileName: file.name,
          process: 0
        })

        const newSampleField = {
          patient: {
            ...sampleField.patient,
            isFq: true,
            fqFiles
          }
        }

        setSampleField(newSampleField)

        try {
          // const { data } = await axios
          //   .post('/api/oss/fastq_uploads/', formData, config)
          //   .catch((err) => {
          //     //
          //   })

          // OSS

          setAbortCheckpoint([])
          const client = await handleOss()

          const data = await upFile(
            client,
            file,
            'fastq_uploads',
            setSampleField,
            undefined,
            newSampleField
          )

          //

          if (data) {
            messageRef?.current?.handleClick(t('Upload successful'), 'success')
          }
        } catch (error) {
          messageRef?.current?.handleClick(
            t('Upload failed') + String(error),
            'error'
          )

          console.error('Upload error:', error)
        }
      }
    }

    const handleFqFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      // if (sampleField.patient.fqFiles.some((item) => item.process !== 100))
      //   return messageRef?.current?.handleClick(
      //     t('The document is being uploaded. Please wait a moment'),
      //     'warning'
      //   )

      if (event.target.files && event.target.files.length > 0) {
        Array.from(event.target.files).map((file) => {
          handleFqUpload(file)
        })
      }
    }

    const handleCnvUpload = async (file: File) => {
      if (file) {
        const formData = new FormData()

        formData.append('file', file)

        const config: AxiosRequestConfig = {
          onUploadProgress: (progressEvent: any) => {
            const progress = Math.round(
              (progressEvent.loaded / progressEvent.total) * 100
            )

            setCnvProcess(progress)
          }
        }

        try {
          const { data } = await axios.post(
            '/api/oss/upload/',
            formData,
            config
          )

          if (data) {
            const value = {
              patient: {
                ...sampleField.patient,
                cnvName: file.name,
                cnvFile: file.name,
                hasCnv: true
              }
            }

            setSampleField(value)

            if (file.name.includes('.call.cns')) {
              const params = {
                ...samples,
                hasCnv: 1,
                cnvKitFile: decodeURI(value.patient.cnvFile),
                terms: isJson(samples?.terms as string)
                  ? samples?.terms
                  : JSON.stringify(samples?.terms)
              }

              editSamples.mutateAsync(params as any)
            } else {
              const params = {
                ...samples,
                hasCnv: 1,
                cnvFile: decodeURI(value.patient.cnvFile),
                terms: isJson(samples?.terms as string)
                  ? samples?.terms
                  : JSON.stringify(samples?.terms)
              }

              editSamples.mutateAsync(params as any)
            }

            messageRef?.current?.handleClick(t('Upload successful'), 'success')
          }
        } catch (error) {
          messageRef?.current?.handleClick(
            t('Upload failed') + String(error),
            'error'
          )

          console.error('Upload error:', error)
        }
      }
    }

    const handleCnvFileChange = (
      event: React.ChangeEvent<HTMLInputElement>
    ) => {
      if (event.target.files && event.target.files.length > 0) {
        handleCnvUpload(event.target.files[0])
      }
    }

    const handleGetAssumeRole = useMutation({
      mutationFn: async () => await assumeRole()
    })

    const handleOss = async () => {
      // 向您搭建的STS服务获取临时访问凭证。
      const query = await handleGetAssumeRole.mutateAsync()

      // if (!query || !query.SecurityToken) return
      const client = new OSS({
        // yourRegion填写Bucket所在地域。
        region: 'oss-cn-shenzhen',

        // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
        accessKeyId: query.AccessKeyId,
        accessKeySecret: query.AccessKeySecret,

        // 从STS服务获取的安全令牌（SecurityToken）。
        stsToken: query.SecurityToken,

        // 刷新临时访问凭证的时间间隔，单位为毫秒。
        refreshSTSTokenInterval: 30000000,

        // 填写Bucket名称。
        bucket: 'glsofort'
      })

      setClient(client)

      return client
    }

    const upFile = async (
      clients: OSS,
      file: File,
      filePath = 'uploads',
      setProcess?: any,
      option?: OSS.MultipartUploadOptions,
      samples?: any
    ) => {
      const headers = {
        // 指定该Object被下载时的网页缓存行为。
        'Cache-Control': 'no-cache',

        // 指定该Object被下载时的名称。
        'Content-Disposition': file.name,

        // 指定该Object被下载时的内容编码格式。
        'Content-Encoding': 'utf-8',

        // 指定过期时间，单位为毫秒。
        Expires: '1000',

        // // 指定Object的存储类型。
        // 'x-oss-storage-class': 'Standard',

        // // 指定Object标签，可同时设置多个标签。
        // 'x-oss-tagging': 'Tag1=1&Tag2=2',

        // 指定初始化分片上传时是否覆盖同名Object。此处设置为true，表示禁止覆盖同名Object。
        'x-oss-forbid-overwrite': 'false'
      }
      let options: OSS.MultipartUploadOptions = {
        // 获取分片上传进度、断点和返回值。
        progress: (p: any, cpt: any, res: any) => {
          // //

          if (clients) {
            // 获取进度以及上传文件分片
            if (samples && samples.patient && samples.patient.isFq) {
              let fqFiles = sampleField.patient.fqFiles

              fqFiles = fqFiles.map((items: any) => {
                if (items.fileName === file.name) {
                  items.process = p * 100
                }

                return items
              })

              setKey(Math.random())

              // setProcess({
              //   patient: {
              //     ...sampleField.patient,
              //     isFq: true,
              //     fqFiles
              //   }
              // })

              // //

              // //
            } else setProcess(p * 100)

            const flag = abortCheckpoint.some(
              (item) => item.name === `${filePath}/${file.name}`
            )

            if (flag)
              abortCheckpoint.map((item) => {
                if (item.name === `${filePath}/${file.name}`) {
                  return cpt
                } else return item
              })
            else abortCheckpoint.push(cpt)

            setAbortCheckpoint(abortCheckpoint)
          }
        },

        // 设置并发上传的分片数量。
        parallel: 4,

        // 设置分片大小。默认值为1 MB，最小值为100 KB。
        partSize: 1024 * 1024 * 2,
        headers,
        mime: 'text/plain',
        timeout: 120000 //设置超时时间,
      }
      if (option) options = option

      // const client = await handleOss()

      //

      if (clients) {
        // 上传文件
        const data = (await clients
          .multipartUpload(`${filePath}/${file.name}`, file, {
            ...options
          })
          .catch(async (err) => {
            //更新token
            console.error(err)
            const upClient = await handleOss()

            // 判断是否存在分片数据以及重启次数

            if (client && retryCount < retryCountMax) {
              setRetryCount(retryCount + 1)

              const option = {
                ...options
              }
              const flag = abortCheckpoint.find(
                (item) => item.name === `${filePath}/${file.name}`
              )

              option.checkpoint = flag

              await upFile(
                upClient,
                file,
                filePath,
                setProcess,
                option,
                samples
              )
            }
          })) as any

        //
        const url = data?.res?.requestUrls[0]

        if (url && isValidURL(url)) {
          const newAbortCheckpoint = abortCheckpoint.filter(
            (item) => item.name !== `fastq_uploads/${file.name}`
          )

          setAbortCheckpoint(newAbortCheckpoint)

          return url
        } else return null
      } else return null
    }

    const handleSaveGeneSets = (geneSet: any) => {
      if ('name' in geneSet && 'id' in geneSet) {
        updateGeneSetsMutation.mutate(geneSet)
      } else {
        createGeneSetsMutation.mutate(geneSet)
      }
    }

    const createGeneSetsMutation = useMutation(createGeneSets, {
      onSuccess: () => {
        setOpenRol(false)

        refetchRol()
      }
    })
    const updateGeneSetsMutation = useMutation(editGeneSets, {
      onSuccess: () => {
        setOpenRol(false)

        refetchRol()
      }
    })

    const { data: geneSets, refetch: refetchRol } = useQuery<GeneSets[]>(
      ['geneSets'],
      async () =>
        await getGeneSets({
          pageNum: 1,
          pageSize: 1000
        }),
      {
        keepPreviousData: true
      }
    )

    const { data: projects, refetch } = useQuery<Project[]>(
      'data',
      async () => await fetchProjects({ pageNum: 1, pageSize: 1000 }),
      {
        keepPreviousData: true
      }
    )

    const patientSample = useMutation({
      mutationFn: async (id: number) => await fetchPatientBySampleId(id),
      onSuccess: async (data: {
        list: {
          sample: Sample
          patients: Patients
        }[]
      }) => {
        if (data && data.list && data.list.length) {
          const patient = data.list[0].patients
          const sample = data.list[0].sample
          const projectId = sample && ((sample.projectId ?? '0') as number)
          const temp = projects?.find((item) => item.id === projectId)
          const analysisSamples = props?.analysisData?.analysisSamples ?? []
          const analysisSamplesItem = analysisSamples.find(
            (i: any) => i.sampleId === sample.id
          )

          setValues({
            name: temp?.name ?? '',
            id: projectId,
            inputValue: temp?.name
          })

          const params = {
            ...sampleField.patient,
            svName: sample.svFile ?? '',
            svFile: '',
            hasSv: Boolean(sample.hasSv),
            cnvName: sample.cnvFile
              ? sample.cnvFile
              : sample.cnvKitFile
              ? sample.cnvKitFile
              : '',
            cnvFile: '',
            hasCnv: Boolean(sample.hasCnv)
          }

          if (sample.hasCnv) {
            setCnvProcess(100)
          }

          if (sample.hasSv) {
            setSvProcess(100)
          }

          setSampleField({
            patient: params
          })

          const patientFilesParams: PatientsFile = {
            patientId: patient.id
          }

          const patientFiles = await fetchPatientsFileMutation.mutateAsync(
            patientFilesParams
          )

          if (patientFiles && patientFiles.list && patientFiles.list.length) {
            const data = patientFiles.list[0]
            const metadata = patientFiles.list[0].metadata

            if (metadata && isJson(metadata)) {
              setImgSrc({
                name: JSON.parse(metadata).imgName,
                src: JSON.parse(metadata).imgSrc,
                id: data.id
              })
            }
          }
          let dateOfBirth = ''
          if (patient.dateOfBirth) {
            const ageInMs =
              new Date().valueOf() - new Date(patient.dateOfBirth).valueOf()
            const ageInYears = ageInMs / 3.15576e10

            if (ageInYears >= 1) {
              dateOfBirth = String(Math.floor(ageInYears)) + t('years old')
            } else {
              const ageInMonths = ageInYears * 12
              if (ageInMonths >= 1) {
                dateOfBirth = `${Math.floor(ageInMonths)}` + t('months old')
              } else {
                const ageInDays = Math.floor(ageInMs / (1000 * 60 * 60 * 24))
                dateOfBirth = `${ageInDays}` + t('days old')
              }
            }
          }

          reset({
            patientId: patient.id as unknown as string,
            sampleId: sample.id as unknown as string,
            id: patient.id as unknown as string,
            patientName: patient.patientName as unknown as string,
            caseNumber: patient.caseNumber as unknown as string,
            infirmaryName: patient.infirmaryName as unknown as string,
            sampleCode: sample.sampleCode as unknown as string,
            departmentName: patient.departmentName as unknown as string,
            geneSet: (sample.geneSetId ?? '0') as unknown as string,
            primerBedId: (sample.primerBedId ?? '0') as unknown as string,

            // lastName: patient.lastName as unknown as string,
            // dateOfBirth: (patient.dateOfBirth
            //   ? dayjs(patient.dateOfBirth)
            //   : null) as unknown as string,
            dateOfBirth: dateOfBirth,
            BirthData: (patient.dateOfBirth
              ? dayjs(patient.dateOfBirth)
              : '') as unknown as string,
            gender: (patient.gender ?? 'unknown') as unknown as 'male',
            race: (patient.ethnicity ?? '1') as unknown as string,
            sampleType: patient.sampleType as string,
            receiveDate: (patient.receiveDate
              ? dayjs(patient.receiveDate)
              : null) as unknown as string,
            resultsIn: patient.resultsIn as unknown as string,
            collectDate: (patient.arrivalDate
              ? dayjs(patient.arrivalDate)
              : null) as unknown as string,
            project: projectId,
            isAffect: props.samples.type?.includes('affected'),
            isProBand: Boolean(analysisSamplesItem?.isProband),
            physicianName: patient.physicianName as unknown as string,
            familyHistory: patient.familyHistory as unknown as string,
            phenotype: patient.phenotype as unknown as string
          })
        }
      }
    })

    const translateValue = async (value: string[]) => {
      const sourceLanguage = 'en',
        targetLanguage = 'zh'

      const params: TranslateDto = {
        sourceLanguage,
        targetLanguage,
        sourceText: value.join('，')
      }

      const data = await Translate.mutateAsync(params)
      const flag = true
      if (flag) {
        // const data1 = await getHpoTermsMutation.mutateAsync(data)
        const data2 = await getPhenotypeExtractMutation.mutateAsync({
          text: data,
          lang: 'zh',
          format: 'legacy'
        })

        // const parseData = data1.matches ?? []
        const parseData = data2.hpo ?? []
        if (parseData && Array.isArray(parseData)) {
          const newData = unique(parseData, 'name_en').map((i) => {
            return {
              ...i,
              title: `${i.hpo_code}${i.name_en}(${i.name_cn})`,
              keyId: `${i.hpo_code}${i.name_en.toLocaleLowerCase()}`
            }
          })

          //
          setChatQwen(newData)

          setTermList(
            deduplicateArrays(unique([...newData], 'keyId'), termList)
              .filter((item: any) => item.name_en)
              .map((items: any) => {
                return {
                  definition_cn: '',
                  definition_en: '',
                  hpo_code: items.hpo_code ?? '',
                  name_cn: items.name_cn ?? '',
                  name_en: items.name_en ?? '',
                  alt_title: '',
                  cn_title: '',
                  incTitle: '',
                  omim_code: 0,
                  pre_title: items.name_en ?? '',
                  prefix: '',
                  title: `${items.hpo_code}${items.name_en}(${items.name_cn})`
                }
              })
          )
        }
        return
      }
      return []
    }

    const getHpoAndTerms = async () => {
      setBackop(true)

      messageRef?.current?.handleClick('查询中，请稍后', 'info')

      if (!containsChinese(clinicalInformation)) {
        // 英文
        await translateValue(
          clinicalInformation.split(',').join('，').split('，')
        )
      } else {
        const flag = true

        if (flag) {
          // const data1 = await getHpoTermsMutation.mutateAsync(
          //   clinicalInformation
          // )
          const data2 = await getPhenotypeExtractMutation.mutateAsync({
            text: clinicalInformation,
            lang: 'zh',

            format: 'legacy'
          })

          // const parseData = data1.matches ?? []
          const parseData = data2.hpo ?? []
          if (parseData && Array.isArray(parseData)) {
            const newData = unique(parseData, 'name_en').map((i) => {
              return {
                ...i,
                title: `${i.hpo_code}${i.name_en}(${i.name_cn})`,
                keyId: `${i.hpo_code}${i.name_en.toLocaleLowerCase()}`
              }
            })

            //
            setChatQwen(newData)

            setTermList(
              deduplicateArrays(unique([...newData], 'keyId'), termList)
                .filter((item: any) => item.name_en)
                .map((items: any) => {
                  return {
                    definition_cn: '',
                    definition_en: '',
                    hpo_code: items.hpo_code ?? '',
                    name_cn: items.name_cn ?? '',
                    name_en: items.name_en ?? '',
                    alt_title: '',
                    cn_title: '',
                    incTitle: '',
                    omim_code: 0,
                    pre_title: items.name_en ?? '',
                    prefix: '',
                    title: `${items.hpo_code}${items.name_en}(${items.name_cn})`
                  }
                })
            )
          }
          return
        }

        return []
      }

      setBackop(false)
    }

    const updatePatientsMutation = useMutation(editPatients, {
      onSuccess: () => {
        // refetch()
        messageRef?.current?.handleClick(t('Edit success'), 'success')
      }
    })

    const fetchPatientsFileMutation = useMutation(getPatientsFiles, {
      onSuccess: () => {
        // refetch()
      }
    })

    const createPatientsFileMutation = useMutation(createPatientsFiles, {
      onSuccess: async (data) => {
        if (data && data.id) {
          const metadata = data.metadata

          setImgSrc({
            name: JSON.parse(metadata).imgName,
            src: JSON.parse(metadata).imgSrc,
            id: data.id
          })
        }
      }
    })

    const updatePatientsFileMutation = useMutation(editPatientsFiles, {
      onSuccess: () => {
        // refetch()
      }
    })

    const deletePatientsFileMutation = useMutation(deletePatientsFiles, {
      onSuccess: async (data, params) => {
        //
      }
    })

    const createProjectMutation = useMutation(createProject, {
      onSuccess: () => {
        messageRef?.current?.handleClick(t('New successful'), 'success')

        refetch()
      },
      onError: (err: any) => {
        //

        messageRef?.current?.handleClick(
          err?.response?.data?.message ?? '请重试',
          'error'
        )
      }
    })

    const Translate = useMutation({
      mutationFn: async (data: TranslateDto) => await translate(data),
      onSuccess: (data, params, context) => {
        //post返回的结果
        // if (params.sourceLanguage === 'zh')
        //   GetTermByClinicalInfo.mutateAsync({
        //     clinicalInfo: data
        //   })
      }
    })

    const Translates = useMutation({
      mutationFn: async (data: TranslateBulkDto) => await translates(data),
      onSuccess: (
        data: { translated: string; wordCount: string; index: string }[],
        params
      ) => {
        //post返回的结果
        // if (params.sourceLanguage === 'en') {
        //   const terms = data.map((items) => {
        //     const en = params.sourceText[Number(items.index)]
        //     return {
        //       definition_cn: '',
        //       definition_en: '',
        //       hpo_code: '',
        //       name_cn: items.translated,
        //       name_en: en,
        //       alt_title: '',
        //       cn_title: '',
        //       incTitle: '',
        //       omim_code: 0,
        //       pre_title: en,
        //       prefix: '',
        //       title: `${en}(${items.translated})`
        //     }
        //   })
        //   setTermList(unique([...termList, ...terms], 'name_en'))
        // }
      }
    })

    const GetTermByClinicalInfo = useMutation({
      mutationFn: async (data: GetTermsByClinicalInfoDto) =>
        await getTermByClinicalInfo(data),
      onSuccess: async (data: { terms: string[] }) => {
        //post返回的结果
        // const sourceLanguage = 'en',
        //   targetLanguage = 'zh'
        // const obj = {} as any
        // data.terms.map((item, index) => {
        //   obj[index] = item
        // })
        // const params: TranslateBulkDto = {
        //   sourceText: obj,
        //   sourceLanguage,
        //   targetLanguage
        // }
        // Translates.mutateAsync(params)
      }
    })

    const editSamples = useMutation({
      mutationFn: async (data: Sample) => await editSample(data),
      onSuccess: (data: Sample) => {
        //post返回的结果
        // refetch()
        messageRef?.current?.handleClick(t('Edit success'), 'success')
      }
    })

    const getChatQwenApp = useMutation({
      mutationFn: async (data: ChatClaudeDto) => await chatQwenApp(data),
      onSuccess: (data: string) => {
        //post返回的结果
        // refetch()
        setBackop(false)
      },
      onError: () => {
        setBackop(false)
      }
    })

    const getHpoTermsMutation = useMutation({
      mutationFn: async (data: string) => await getHpoTerms(data),
      onSuccess: (data: { matches: any[] }) => {
        //post返回的结果
        // refetch()
        setBackop(false)
      },
      onError: () => {
        setBackop(false)
      }
    })

    const getPhenotypeExtractMutation = useMutation({
      mutationFn: async (data: {
        text: string
        lang: string
        format: string
      }) => await phenotypeExtract(data),
      onSuccess: (data: { hpo: any[] }) => {
        //post返回的结果
        // refetch()
        setBackop(false)
      },
      onError: () => {
        setBackop(false)
      }
    })

    const editAnalyzeSamples = useMutation({
      mutationFn: async (data: any) => await updataAnalyzeSample(data),
      onSuccess: (data: any) => {
        //post返回的结果
        // refetch()
        props.refetchAnalyzeInfo && props.refetchAnalyzeInfo()

        messageRef?.current?.handleClick(t('Edit success'), 'success')
      }
    })

    // 修改分析
    const handleEditAna = useMutation({
      mutationFn: async (data: Analysis) => await editAnalysis(data),
      onError(error) {
        messageRef?.current?.handleClick(String(error), 'error')
      },
      onSuccess: () => {
        messageRef?.current?.handleClick(t('Edit success'), 'success')
      }
    })

    // ** Hooks
    const {
      control: Control,
      handleSubmit: handleSubmit,
      formState: { errors: Errors },
      reset,
      setValue
    } = useForm({
      defaultValues: defaultValues,
      resolver: yupResolver(schema)
    })

    const handleChange = (event: SelectChangeEvent) => {
      setRace(event.target.value as string)
    }

    const saveClinical = async () => {
      if (type === 'sample') {
        const sampleType = samples?.sampleType

        const params = {
          ...samples,
          clinicalInformation,
          terms: JSON.stringify(termList),
          status: samples?.status
        }

        await editSamples.mutateAsync(params as any)
      } else {
        const sampleType = samples?.sampleType

        const sampleParams = {
          ...samples,
          clinicalInformation,
          terms: JSON.stringify(termList),
          status: samples?.status
        }

        await editSamples.mutateAsync(sampleParams as any)
        const status = props.analysisInfo.status
        const params = {
          ...props.analysisData,
          status: status
        }

        delete params.analysisItems

        delete params.analysisSamples

        await handleEditAna.mutateAsync(params as any)
      }
    }

    const savePatientl = (data: any) => {
      //edit

      let isSwitchProBand = false

      const analysisSamples = props?.analysisData?.analysisSamples ?? []
      const oldProBand = analysisSamples.find((item: any) => item.isProband)

      if (data.isProBand) {
        isSwitchProBand = true
      }

      //

      if (data.id) {
        const patientParams = {
          // lastName: data.lastName,
          patientName: data.patientName,
          dateOfBirth: formatDate(data.BirthData.$d as any) as unknown as Date,
          gender: data.gender,
          ethnicity: data.race === '1' ? '' : data.race,
          receiveDate: (data.receiveDate
            ? formatDate(data.receiveDate.$d as any)
            : '') as unknown as Date,
          resultsIn: data.resultsIn,
          physicianName: data.physicianName,
          familyHistory: data.familyHistory,
          phenotype: data.phenotype,
          infirmaryName: data.infirmaryName,
          sampleCode: data.sampleCode,
          departmentName: data.departmentName,
          caseNumber: data.caseNumber,
          id: data.id as number,
          sampleType: data.sampleType,
          arrivalDate: (data.collectDate
            ? formatDate(data.collectDate.$d as any)
            : '') as unknown as string
        }

        updatePatientsMutation.mutateAsync(patientParams)
        const params = {
          ...samples,
          clinicalInformation,
          projectId: (data.project as any) == '0' ? null : data.project,
          terms: JSON.stringify(termList),
          geneSetId:
            data.geneSet === '0' || data.geneSet === 'null'
              ? null
              : data.geneSet,
          primerBedId:
            data.primerBedId === '0' || data.primerBedId === 'null'
              ? null
              : data.primerBedId,
          status: samples?.status

          // status: 'vcf_annotated'
        }

        if (
          type === 'analyze' &&
          (props.analysisInfo.analysisType === 'big_family' ||
            props.analysisInfo.analysisType === 'family_analysis')
        ) {
          if (isSwitchProBand) {
            const status = props.analysisData.status
            const params = {
              ...props.analysisData,
              status: status === 'imported' ? 'queueing' : status
            }

            delete params.analysisItems

            delete params.analysisSamples

            handleEditAna.mutateAsync(params as any)
            if (oldProBand) {
              const saveOldAnalyzeSampleParams = {
                analysisId: oldProBand.analysisId,
                sampleId: oldProBand.id,
                type: oldProBand.type,
                isProband: 0
              }

              editAnalyzeSamples.mutateAsync(saveOldAnalyzeSampleParams)
            }

            messageApi.warning(
              t('Please bear with me for a moment during the analysis.')
            )
          }

          const saveAnalyzeSampleParams = {
            analysisId: props.samples.analysisId,
            sampleId: props.samples.id,
            type: props.samples.type,
            clinicalInformation,
            terms: JSON.stringify(termList),
            isProband: Number(isSwitchProBand)
          }

          if (props.samples.type?.includes('affected')) {
            const sampleType = props.samples.type.includes('//')
              ? props.samples.type.split('//')[0].split('_')[1]
              : props.samples.type.split('_')[1]

            if (data.isAffect) {
              saveAnalyzeSampleParams.type = `affected_${sampleType}`
            } else saveAnalyzeSampleParams.type = `${sampleType}`
          } else if (props.samples.type) {
            const sampleType = props.samples.type.includes('//')
              ? props.samples.type.split('//')[0]
              : props.samples.type
            if (data.isAffect) {
              saveAnalyzeSampleParams.type = `affected_${sampleType}`
            } else saveAnalyzeSampleParams.type = `${sampleType}`
          }

          editAnalyzeSamples.mutateAsync(saveAnalyzeSampleParams)
        }

        delete params.project

        editSamples.mutateAsync(params as any)
      }

      //create
    }

    return (
      <Box overflow="auto" paddingRight={5}>
        {contextHolder}

        <Grid container>
          {/* <Grid item xs={2}>
            <Button
              variant="contained"
              startIcon={<Plus />}

              sx={{ marginLeft: 2, marginBottom: 3 }}
            >
              上传文件
            </Button>

            <Typography sx={{ fontSize: 22 }}>文件列表</Typography>

            <Box paddingRight={5}>
              <List
                sx={{
                  width: '100%',
                  maxWidth: 360,
                  bgcolor: 'background.paper',
                  display: 'flex',
                  alignContent: 'center'
                }}
              >
                {reportList.map((items) => {
                  return (
                    <ListItemStyled key={items.name}>
                      <ListItemIcon>
                        <Icon icon={'mdi:file'} />
                      </ListItemIcon>

                      <ListItemText
                        primary={items.name}
                        primaryTypographyProps={{
                          noWrap: true

                          // sx: {
                          //   fontWeight: 500,
                          //   ...(props.index === items.index && {
                          //     color: 'primary.main'
                          //   })
                          // }
                        }}
                      />
                    </ListItemStyled>
                  )
                })}
              </List>
            </Box>
          </Grid> */}

          <Grid item xs={12}>
            <Grid container spacing={6} direction="column-reverse">
              <Grid item xs={12}>
                <Card sx={{ width: '100%' }}>
                  <form onSubmit={handleSubmit(savePatientl)}>
                    <CardContent sx={{ paddingBottom: '0px !important' }}>
                      <Grid container spacing={4}>
                        <Grid
                          item
                          xs={12}
                          display={'flex'}
                          alignItems="center"
                          justifyContent={'space-between'}
                        >
                          <Typography
                            sx={{
                              '::before': {
                                content: '""',
                                display: 'inline-block',
                                width: 4,
                                height: '1.25rem',
                                bgcolor: 'primary.main',
                                position: 'absolute',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                left: '-10px'
                              },
                              lineHeight: '1.25em',
                              position: 'relative',
                              ml: '10px'
                            }}
                            fontSize={15}
                          >
                            {t('Basic Information')}
                          </Typography>

                          {/* {props.samples.id != id ? (
                            <Box>
                              <Button
                                onClick={() => {
                                  window.open(
                                    `/samples/SampleTabs/${props.samples.id}`
                                  )
                                }}
                                variant="contained"
                                size="small"
                              >
                                {t('View')}
                              </Button>
                            </Box>
                          ) : (
                            ''
                          )} */}
                        </Grid>

                        <Grid item xs={12}>
                          <Grid container spacing={4} sx={{ marginBottom: 6 }}>
                            <Grid item xs={12} sm={6} lg={2.4}>
                              <Box
                                className={'flex items-center gap-2'}
                                alignItems="center"
                              >
                                <Typography
                                  className="font-medium"
                                  color="text.primary"
                                  sx={{
                                    wordBreak: 'keep-all',
                                    mr: 2
                                  }}
                                  flex={2}
                                  textAlign="right"
                                >
                                  {t('Sample Id')}:
                                </Typography>

                                <FormControl
                                  sx={{
                                    flex: 5
                                  }}
                                  fullWidth
                                >
                                  <Controller
                                    name="sampleId"
                                    control={Control}
                                    rules={{ required: true }}
                                    render={({
                                      field: { value, onChange }
                                    }) => (
                                      <TextField
                                        value={value}
                                        onChange={(e) => {
                                          onChange(e)
                                        }}
                                        size={'small'}
                                        disabled
                                        error={Boolean(Errors.sampleId)}
                                      />
                                    )}
                                  />

                                  {Errors.sampleId && (
                                    <FormHelperText
                                      sx={{ color: 'error.main' }}
                                    >
                                      {Errors.sampleId.message}
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              </Box>
                            </Grid>

                            <Grid item xs={12} sm={6} lg={2.4}>
                              <Box
                                className={'flex items-center gap-2'}
                                alignItems="center"
                              >
                                <Typography
                                  className="font-medium"
                                  color="text.primary"
                                  sx={{
                                    wordBreak: 'keep-all',
                                    mr: 2
                                  }}
                                  flex={2}
                                  textAlign="right"
                                >
                                  {t('Patient Id')}:
                                </Typography>

                                <FormControl
                                  sx={{
                                    flex: 5
                                  }}
                                  fullWidth
                                >
                                  <Controller
                                    name="patientId"
                                    control={Control}
                                    rules={{ required: true }}
                                    render={({
                                      field: { value, onChange }
                                    }) => (
                                      <TextField
                                        value={value}
                                        onChange={(e) => {
                                          onChange(e)
                                        }}
                                        size={'small'}
                                        disabled
                                        error={Boolean(Errors.patientId)}
                                      />
                                    )}
                                  />

                                  {Errors.patientId && (
                                    <FormHelperText
                                      sx={{ color: 'error.main' }}
                                    >
                                      {Errors.patientId.message}
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              </Box>
                            </Grid>

                            <Grid item xs={12} sm={6} lg={2.4}>
                              <Box
                                className={'flex items-center gap-2'}
                                alignItems="center"
                              >
                                <Typography
                                  className="font-medium"
                                  color="text.primary"
                                  sx={{
                                    wordBreak: 'keep-all',
                                    mr: 2
                                  }}
                                  flex={2}
                                  textAlign="right"
                                >
                                  {t('Patient Name')}:
                                </Typography>

                                <FormControl
                                  sx={{
                                    flex: 5
                                  }}
                                  fullWidth
                                >
                                  <Controller
                                    name="patientName"
                                    control={Control}
                                    rules={{ required: true }}
                                    render={({
                                      field: { value, onChange }
                                    }) => (
                                      <TextField
                                        value={value}
                                        onChange={(e) => {
                                          onChange(e)
                                        }}
                                        size={'small'}
                                        placeholder={`${t(
                                          'Please enter the'
                                        )} ${t('patientName')}`}
                                        error={Boolean(Errors.patientName)}
                                      />
                                    )}
                                  />

                                  {Errors.patientName && (
                                    <FormHelperText
                                      sx={{ color: 'error.main' }}
                                    >
                                      {Errors.patientName.message}
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              </Box>
                            </Grid>

                            <Grid item xs={12} sm={6} lg={2.4}>
                              <Box
                                className={'flex items-center gap-2'}
                                alignItems="center"
                              >
                                <Typography
                                  className="font-medium"
                                  color="text.primary"
                                  sx={{
                                    wordBreak: 'keep-all',
                                    mr: 2
                                  }}
                                  flex={2}
                                  textAlign="right"
                                >
                                  {t('Age')}:
                                </Typography>

                                <Box
                                  className={'flex items-center gap-2'}
                                  alignItems="center"
                                  sx={{
                                    flex: 5
                                  }}
                                >
                                  <FormControl fullWidth>
                                    <Controller
                                      name="dateOfBirth"
                                      control={Control}
                                      rules={{ required: true }}
                                      disabled
                                      render={({
                                        field: { value, onChange }
                                      }) => (
                                        <TextField
                                          value={value}
                                          disabled
                                          onChange={(e) => {
                                            onChange(e)
                                          }}
                                          size={'small'}
                                          error={Boolean(Errors.dateOfBirth)}
                                        />
                                      )}
                                    />

                                    {Errors.dateOfBirth && (
                                      <FormHelperText
                                        sx={{ color: 'error.main' }}
                                      >
                                        {Errors.dateOfBirth.message}
                                      </FormHelperText>
                                    )}
                                  </FormControl>
                                </Box>
                              </Box>
                            </Grid>

                            <Grid item xs={12} sm={6} lg={2.4}>
                              <Box
                                className={'flex items-center gap-2'}
                                alignItems="center"
                              >
                                <Typography
                                  className="font-medium"
                                  color="text.primary"
                                  sx={{
                                    wordBreak: 'keep-all',
                                    mr: 2
                                  }}
                                  flex={2}
                                  textAlign="right"
                                >
                                  {t('Ethnicity')}:
                                </Typography>

                                <FormControl
                                  sx={{
                                    flex: 5
                                  }}
                                  fullWidth
                                >
                                  <Controller
                                    name="race"
                                    control={Control}
                                    rules={{ required: true }}
                                    render={({
                                      field: { value, onChange }
                                    }) => {
                                      return (
                                        <React.Fragment>
                                          <Select
                                            value={value}
                                            onChange={(e) => {
                                              onChange(e)
                                            }}
                                            error={Boolean(Errors.race)}
                                            size={'small'}
                                            IconComponent={
                                              ExpandCircleDownOutlinedIcon
                                            }
                                          >
                                            <MenuItem value={'1'} disabled>
                                              {`${t('Please select the')} ${t(
                                                'Ethnicity'
                                              )}`}
                                            </MenuItem>

                                            <MenuItem value={'EastAsia'}>
                                              {t('East Asia')}
                                            </MenuItem>

                                            <MenuItem value={'America'}>
                                              {t('America')}
                                            </MenuItem>

                                            <MenuItem value={'Mediterranean'}>
                                              {t('Mediterranean')}
                                            </MenuItem>

                                            <MenuItem value={'WhiteRace'}>
                                              {t('WhiteRace')}
                                            </MenuItem>
                                          </Select>
                                        </React.Fragment>
                                      )
                                    }}
                                  />

                                  {Errors.race && (
                                    <FormHelperText
                                      sx={{ color: 'error.main' }}
                                    >
                                      {Errors.race.message}
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              </Box>
                            </Grid>

                            <Grid item xs={12} sm={6} lg={2.4}>
                              <Box
                                className={'flex items-center gap-2'}
                                alignItems="center"
                              >
                                <Typography
                                  className="font-medium"
                                  color="text.primary"
                                  sx={{
                                    wordBreak: 'keep-all',
                                    mr: 2
                                  }}
                                  flex={2}
                                  textAlign="right"
                                >
                                  {t('Gender')}:
                                </Typography>

                                <FormControl
                                  fullWidth
                                  sx={{
                                    alignItems: 'center',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    height: '100%',
                                    border: '1px solid rgb(212,211,213)',
                                    borderRadius: '6px',
                                    pl: '1rem',
                                    flex: 5
                                  }}
                                >
                                  <Controller
                                    name="gender"
                                    control={Control}
                                    rules={{ required: true }}
                                    render={({
                                      field: { value, onChange }
                                    }) => (
                                      <React.Fragment>
                                        <RadioGroup
                                          row
                                          aria-labelledby="demo-row-radio-buttons-group-label"
                                          name="row-radio-buttons-group"
                                          value={value}
                                          onChange={(e) => {
                                            onChange(e)
                                          }}
                                        >
                                          <FormControlLabel
                                            value="male"
                                            control={<Radio size="small" />}
                                            label={t('male')}
                                          />

                                          <FormControlLabel
                                            value="female"
                                            control={<Radio size="small" />}
                                            label={t('female')}
                                          />

                                          <FormControlLabel
                                            value="unknown"
                                            control={<Radio size="small" />}
                                            label={t('unknown')}
                                          />
                                        </RadioGroup>
                                      </React.Fragment>
                                    )}
                                  />

                                  {Errors.gender && (
                                    <FormHelperText
                                      sx={{ color: 'error.main' }}
                                    >
                                      {Errors.gender.message}
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              </Box>
                            </Grid>

                            <Grid item xs={12} sm={6} lg={2.4}>
                              <Box
                                className={'flex items-center gap-2'}
                                alignItems="center"
                              >
                                <Typography
                                  className="font-medium"
                                  color="text.primary"
                                  sx={{
                                    wordBreak: 'keep-all',
                                    mr: 2
                                  }}
                                  flex={2}
                                  textAlign="right"
                                >
                                  {t('Sample Types')}:
                                </Typography>

                                <FormControl
                                  sx={{
                                    flex: 5
                                  }}
                                  fullWidth
                                >
                                  <Controller
                                    name="sampleType"
                                    control={Control}
                                    rules={{ required: true }}
                                    render={({
                                      field: { value, onChange }
                                    }) => (
                                      <React.Fragment>
                                        <Select
                                          value={value}
                                          onChange={(e) => {
                                            onChange(e)
                                          }}
                                          IconComponent={
                                            ExpandCircleDownOutlinedIcon
                                          }
                                          size={'small'}
                                          placeholder={`${t(
                                            'Please enter the'
                                          )} ${t('sampleType')}`}
                                          error={Boolean(Errors.sampleType)}
                                        >
                                          <MenuItem value={''}></MenuItem>

                                          <MenuItem value={'DNA'}>
                                            {t('DNA')}
                                          </MenuItem>

                                          <MenuItem value={'blood'}>
                                            {t('blood')}
                                          </MenuItem>

                                          <MenuItem value={'saliva'}>
                                            {t('saliva')}
                                          </MenuItem>

                                          <MenuItem value={'mouth-swab'}>
                                            {t('mouth swab')}
                                          </MenuItem>

                                          <MenuItem value={'amniotic-fluid'}>
                                            {t('amniotic fluid')}
                                          </MenuItem>

                                          <MenuItem value={'umbilical-blood'}>
                                            {t('umbilical blood')}
                                          </MenuItem>

                                          <MenuItem value={'aborted-tissue'}>
                                            {t('aborted tissue')}
                                          </MenuItem>

                                          <MenuItem
                                            value={'外周血（EDTA 采血管）'}
                                          >
                                            {t('外周血(EDTA采血管)')}
                                          </MenuItem>
                                        </Select>
                                      </React.Fragment>
                                    )}
                                  />

                                  {Errors.sampleType && (
                                    <FormHelperText
                                      sx={{ color: 'error.main' }}
                                    >
                                      {Errors.sampleType.message}
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              </Box>
                            </Grid>

                            <Grid item xs={12} sm={6} lg={2.4}>
                              <Box
                                className={'flex items-center gap-2'}
                                alignItems="center"
                              >
                                <Typography
                                  className="font-medium"
                                  color="text.primary"
                                  sx={{
                                    wordBreak: 'keep-all',
                                    mr: 2
                                  }}
                                  flex={2}
                                  textAlign="right"
                                >
                                  {t('Date of Birth')}:
                                </Typography>

                                <FormControl
                                  sx={{
                                    flex: 5
                                  }}
                                  fullWidth
                                >
                                  <Controller
                                    name="BirthData"
                                    control={Control}
                                    rules={{ required: true }}
                                    render={({
                                      field: { value, onChange }
                                    }) => (
                                      <LocalizationProvider
                                        dateAdapter={AdapterDayjs}
                                      >
                                        <DatePicker
                                          value={value}
                                          onChange={(e) => {
                                            onChange(e)
                                          }}
                                          sx={{
                                            width: '100%',
                                            '& .MuiInputBase-input': {
                                              height: '0.45rem'
                                            }
                                          }}
                                        />
                                      </LocalizationProvider>
                                    )}
                                  />

                                  {Errors.BirthData && (
                                    <FormHelperText
                                      sx={{ color: 'error.main' }}
                                    >
                                      {Errors.BirthData.message}
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              </Box>
                            </Grid>

                            <Grid item xs={12} sm={6} lg={2.4}>
                              <Box
                                className={'flex items-center gap-2'}
                                alignItems="center"
                              >
                                <Typography
                                  className="font-medium"
                                  color="text.primary"
                                  sx={{
                                    wordBreak: 'keep-all',
                                    mr: 2
                                  }}
                                  flex={2}
                                  textAlign="right"
                                >
                                  {t('Affiliated Project')}:
                                </Typography>

                                <FormControl
                                  sx={{
                                    flex: 5
                                  }}
                                  fullWidth
                                >
                                  {/* <Controller
                                    name="project"
                                    control={Control}
                                    rules={{ required: true }}
                                    render={({
                                      field: { value, onChange }
                                    }) => (
                                      <React.Fragment>
                                        <Select
                                          value={value}
                                          onChange={(e) => {
                                            onChange(e)
                                          }}
                                          size={'small'}
                                          IconComponent={
                                            ExpandCircleDownOutlinedIcon
                                          }
                                          error={Boolean(Errors.race)}
                                        >
                                          <MenuItem value={'0'} disabled>
                                            {`${t('Please select the')} ${t(
                                              'project'
                                            )}`}
                                          </MenuItem>

                                          {projects?.map((item) => {
                                            return (
                                              <MenuItem
                                                key={item.id}
                                                value={item.id}
                                              >
                                                {item.name}
                                              </MenuItem>
                                            )
                                          })}
                                        </Select>
                                      </React.Fragment>
                                    )}
                                  />

                                  {Errors.project && (
                                    <FormHelperText
                                      sx={{ color: 'error.main' }}
                                    >
                                      {Errors.project.message}
                                    </FormHelperText>
                                  )} */}

                                  <Autocomplete
                                    fullWidth
                                    value={value}
                                    onChange={async (event, newValue) => {
                                      //

                                      if (
                                        typeof newValue !== 'string' &&
                                        newValue &&
                                        newValue.id
                                      ) {
                                        setValues(newValue)

                                        setValue('project', newValue.id)
                                      } else {
                                        if (typeof newValue === 'string') {
                                          setValues({
                                            name: newValue
                                          })

                                          const params = {
                                            name: newValue,
                                            isPublic: 0 as 0 | 1,
                                            createdAt: new Date(),
                                            description: ''
                                          }
                                          const project =
                                            await createProjectMutation.mutateAsync(
                                              params
                                            )

                                          const temp = project.find(
                                            (item: any) =>
                                              item.name === params.name
                                          )

                                          //

                                          setValue('project', temp.id)
                                        } else if (
                                          newValue &&
                                          newValue.inputValue
                                        ) {
                                          // Create a new value from the user input
                                          setValues({
                                            name: newValue.inputValue
                                          })
                                          const params = {
                                            name: newValue.inputValue,
                                            isPublic: 0 as 0 | 1,
                                            createdAt: new Date(),
                                            description: ''
                                          }
                                          const project =
                                            await createProjectMutation.mutateAsync(
                                              params
                                            )

                                          const temp = project.find(
                                            (item: any) =>
                                              item.name === params.name
                                          )

                                          setValue('project', temp.id)

                                          //
                                        } else {
                                          setValues(newValue)

                                          setValue('project', 0)
                                        }
                                      }
                                    }}
                                    filterOptions={(options, params) => {
                                      const filtered = filter(options, params)

                                      const { inputValue } = params

                                      // Suggest the creation of a new value
                                      const isExisting = options.some(
                                        (option) => inputValue === option.name
                                      )

                                      if (inputValue !== '' && !isExisting) {
                                        filtered.push({
                                          inputValue,
                                          name: `添加 "${inputValue}"`
                                        })
                                      }

                                      return filtered
                                    }}
                                    size="small"
                                    selectOnFocus
                                    clearOnBlur
                                    handleHomeEndKeys
                                    id="free-solo-with-text-demo"
                                    options={
                                      (projects &&
                                        projects.map((item) => {
                                          return {
                                            id: item.id,
                                            name: item.name,
                                            inputValue: item.name
                                          }
                                        })) ??
                                      []
                                    }
                                    getOptionLabel={(option) => {
                                      // Value selected with enter, right from the input
                                      if (typeof option === 'string') {
                                        return option
                                      }

                                      // Add "xxx" option created dynamically
                                      if (option.name) {
                                        return option.name
                                      }

                                      // Regular option
                                      return option.name
                                    }}
                                    renderOption={(props, option) => {
                                      return <li {...props}>{option.name}</li>
                                    }}
                                    freeSolo
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder={`${t(
                                          'Please select the'
                                        )} ${t('project')}`}
                                      />
                                    )}
                                  />
                                </FormControl>
                              </Box>
                            </Grid>

                            <Grid item xs={12} sm={6} lg={2.4}>
                              <Box
                                className={'flex items-center gap-2'}
                                alignItems="center"
                              >
                                <Typography
                                  className="font-medium"
                                  color="text.primary"
                                  sx={{
                                    wordBreak: 'keep-all',
                                    mr: 2
                                  }}
                                  flex={2}
                                  textAlign="right"
                                >
                                  {t('Collection Date')}:
                                </Typography>

                                <FormControl
                                  sx={{
                                    flex: 5
                                  }}
                                  fullWidth
                                >
                                  <Controller
                                    name="collectDate"
                                    control={Control}
                                    rules={{ required: true }}
                                    render={({
                                      field: { value, onChange }
                                    }) => (
                                      <LocalizationProvider
                                        dateAdapter={AdapterDayjs}
                                      >
                                        <DatePicker
                                          value={value}
                                          onChange={(e) => {
                                            onChange(e)
                                          }}
                                          sx={{
                                            width: '100%',
                                            '& .MuiInputBase-input': {
                                              height: '0.45rem'
                                            }
                                          }}
                                        />
                                      </LocalizationProvider>
                                    )}
                                  />

                                  {Errors.collectDate && (
                                    <FormHelperText
                                      sx={{ color: 'error.main' }}
                                    >
                                      {Errors.collectDate.message}
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              </Box>
                            </Grid>

                            <Grid item xs={12} sm={6} lg={2.4}>
                              <Box
                                className={'flex items-center gap-2'}
                                alignItems="center"
                              >
                                <Typography
                                  className="font-medium"
                                  color="text.primary"
                                  sx={{
                                    wordBreak: 'keep-all',
                                    mr: 2
                                  }}
                                  flex={2}
                                  textAlign="right"
                                >
                                  {t('Receive Date')}:
                                </Typography>

                                <FormControl
                                  sx={{
                                    flex: 5
                                  }}
                                  fullWidth
                                >
                                  <Controller
                                    name="receiveDate"
                                    control={Control}
                                    rules={{ required: true }}
                                    render={({
                                      field: { value, onChange }
                                    }) => (
                                      <LocalizationProvider
                                        dateAdapter={AdapterDayjs}
                                      >
                                        <DatePicker
                                          value={value}
                                          onChange={(e) => {
                                            onChange(e)
                                          }}
                                          sx={{
                                            width: '100%',
                                            '& .MuiInputBase-input': {
                                              height: '0.45rem'
                                            }
                                          }}
                                        />
                                      </LocalizationProvider>
                                    )}
                                  />

                                  {Errors.receiveDate && (
                                    <FormHelperText
                                      sx={{ color: 'error.main' }}
                                    >
                                      {Errors.receiveDate.message}
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              </Box>
                            </Grid>

                            <Grid item xs={12} sm={6} lg={2.4}>
                              <Box
                                className={'flex items-center gap-2'}
                                alignItems="center"
                              >
                                <Typography
                                  className="font-medium"
                                  color="text.primary"
                                  sx={{
                                    wordBreak: 'keep-all',
                                    mr: 2
                                  }}
                                  flex={2}
                                  textAlign="right"
                                >
                                  {t('Results In')}:
                                </Typography>

                                <FormControl
                                  sx={{
                                    flex: 5
                                  }}
                                  fullWidth
                                >
                                  <Controller
                                    name="resultsIn"
                                    control={Control}
                                    rules={{ required: true }}
                                    render={({
                                      field: { value, onChange }
                                    }) => (
                                      <TextField
                                        value={value}
                                        onChange={(e) => {
                                          onChange(e)
                                        }}
                                        size={'small'}
                                        placeholder={`${t(
                                          'Please enter the'
                                        )} ${t('resultsIn')}`}
                                        error={Boolean(Errors.resultsIn)}
                                      />
                                    )}
                                  />

                                  {Errors.resultsIn && (
                                    <FormHelperText
                                      sx={{ color: 'error.main' }}
                                    >
                                      {Errors.resultsIn.message}
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              </Box>
                            </Grid>

                            <Grid item xs={12} sm={6} lg={2.4}>
                              <Box
                                className={'flex items-center gap-2'}
                                alignItems="start"
                              >
                                <Stack flex={2}>
                                  <Typography
                                    className="font-medium"
                                    color="text.primary"
                                    sx={{
                                      wordBreak: 'keep-all',
                                      mr: 2,
                                      mt: '8px'
                                    }}
                                    textAlign="right"
                                  >
                                    {t('Case Number')}:
                                  </Typography>

                                  <div
                                    {...getRootProps({
                                      className: 'dropzone'
                                    })}
                                  >
                                    <input
                                      {...getInputProps()}
                                      accept={'.png,.img'}
                                    />

                                    <FormHelperText
                                      sx={{
                                        cursor: 'pointer',
                                        color: 'primary.main',
                                        marginTop: '20px',
                                        mr: 2
                                      }}
                                    >
                                      {t('Upload of case pictures')}
                                    </FormHelperText>
                                  </div>
                                </Stack>

                                <FormControl
                                  sx={{
                                    flex: 5
                                  }}
                                  fullWidth
                                >
                                  <Controller
                                    name="caseNumber"
                                    control={Control}
                                    rules={{ required: true }}
                                    render={({
                                      field: { value, onChange }
                                    }) => (
                                      <TextField
                                        value={value}
                                        onChange={(e) => {
                                          onChange(e)
                                        }}
                                        size={'small'}
                                        placeholder={`${t(
                                          'Please enter the'
                                        )} ${t('caseNumber')}`}
                                        error={Boolean(Errors.caseNumber)}
                                      />
                                    )}
                                  />

                                  {Errors.caseNumber && (
                                    <FormHelperText
                                      sx={{ color: 'error.main' }}
                                    >
                                      {Errors.caseNumber.message}
                                    </FormHelperText>
                                  )}

                                  {imgSrc.name ? (
                                    <FormHelperText
                                      sx={{
                                        cursor: 'pointer',
                                        color: 'red'
                                      }}
                                    >
                                      <Stack
                                        direction={'row'}
                                        alignItems="center"
                                      >
                                        <Tooltip title={imgSrc.name}>
                                          <Typography
                                            sx={{
                                              maxWidth: 130,
                                              overflow: 'hidden',
                                              whiteSpace: 'nowrap',
                                              textOverflow: 'ellipsis'
                                            }}
                                            onClick={() => {
                                              setImgOpen(!imgOpen)
                                            }}
                                          >
                                            {imgSrc.name}
                                          </Typography>
                                        </Tooltip>

                                        <IconButton
                                          size="small"
                                          onClick={() => {
                                            setImgSrc({
                                              src: '',
                                              name: '',
                                              id: 0
                                            })

                                            if (imgSrc.id) {
                                              deletePatientsFileMutation.mutateAsync(
                                                imgSrc.id
                                              )
                                            }
                                          }}
                                        >
                                          <Close />
                                        </IconButton>
                                      </Stack>
                                    </FormHelperText>
                                  ) : (
                                    ''
                                  )}
                                </FormControl>
                              </Box>
                            </Grid>

                            <Grid item xs={12} sm={6} lg={2.4}>
                              <Box
                                className={'flex items-center gap-2'}
                                alignItems="start"
                              >
                                <Typography
                                  className="font-medium"
                                  color="text.primary"
                                  sx={{
                                    wordBreak: 'keep-all',
                                    mr: 2,
                                    mt: '8px'
                                  }}
                                  flex={2}
                                  textAlign="right"
                                >
                                  {t('Bed choose')}:
                                </Typography>

                                <FormControl
                                  sx={{
                                    flex: 5
                                  }}
                                  fullWidth
                                >
                                  <Controller
                                    name="geneSet"
                                    control={Control}
                                    rules={{ required: true }}
                                    render={({
                                      field: { value, onChange }
                                    }) => (
                                      <React.Fragment>
                                        <Select
                                          value={value}
                                          onChange={(e) => {
                                            onChange(e)
                                          }}
                                          IconComponent={
                                            ExpandCircleDownOutlinedIcon
                                          }
                                          size={'small'}
                                          error={Boolean(Errors.geneSet)}
                                        >
                                          <MenuItem value={'0'} disabled>
                                            {`${t('Please select the')} ${t(
                                              'Gene Set'
                                            )}`}
                                          </MenuItem>

                                          <MenuItem value={'null'}>
                                            {`${t('null')}`}
                                          </MenuItem>

                                          {geneSets
                                            ?.filter((i) => i.type === 'target')
                                            ?.map((item) => {
                                              return (
                                                <MenuItem
                                                  key={item.id}
                                                  value={item.id}
                                                >
                                                  {item.name}
                                                </MenuItem>
                                              )
                                            })}
                                        </Select>
                                      </React.Fragment>
                                    )}
                                  />

                                  <FormHelperText
                                    sx={{
                                      cursor: 'pointer',
                                      color: 'primary.main'
                                    }}
                                    onClick={() => {
                                      setOpenRol(true)
                                    }}
                                  >
                                    {t('upload')}Bed,
                                    <span>
                                      {t(
                                        'It is recommended to upload or select the appropriate sequencing vendor BED file'
                                      )}
                                    </span>
                                  </FormHelperText>
                                </FormControl>
                              </Box>
                            </Grid>

                            {props.analysisInfo.vcfType === 'amplicon' && (
                              <Grid item xs={12} sm={6} lg={2.4}>
                                <Box
                                  className={'flex items-center gap-2'}
                                  alignItems="start"
                                >
                                  <Typography
                                    className="font-medium"
                                    color="text.primary"
                                    sx={{
                                      wordBreak: 'keep-all',
                                      mr: 2,
                                      mt: '8px'
                                    }}
                                    flex={2}
                                    textAlign="right"
                                  >
                                    {t('Amplification primers')}:
                                  </Typography>

                                  <FormControl
                                    sx={{
                                      flex: 5
                                    }}
                                    fullWidth
                                  >
                                    <Controller
                                      name="primerBedId"
                                      control={Control}
                                      rules={{ required: true }}
                                      render={({
                                        field: { value, onChange }
                                      }) => (
                                        <React.Fragment>
                                          <Select
                                            value={value}
                                            onChange={(e) => {
                                              onChange(e)
                                            }}
                                            IconComponent={
                                              ExpandCircleDownOutlinedIcon
                                            }
                                            size={'small'}
                                            error={Boolean(Errors.primerBedId)}
                                          >
                                            <MenuItem value={'0'} disabled>
                                              {`${t('Please select the')} ${t(
                                                'Amplification primers'
                                              )}`}
                                            </MenuItem>

                                            <MenuItem value={'null'}>
                                              {`${t('null')}`}
                                            </MenuItem>

                                            {geneSets
                                              ?.filter(
                                                (i) => i.type === 'primer'
                                              )
                                              ?.map((item) => {
                                                return (
                                                  <MenuItem
                                                    key={item.id}
                                                    value={item.id}
                                                  >
                                                    {item.name}
                                                  </MenuItem>
                                                )
                                              })}
                                          </Select>
                                        </React.Fragment>
                                      )}
                                    />

                                    <FormHelperText
                                      sx={{
                                        cursor: 'pointer',
                                        color: 'primary.main'
                                      }}
                                      onClick={() => {
                                        setOpenRol(true)
                                      }}
                                    >
                                      {t('upload')}Bed,
                                      <span>
                                        {t(
                                          'It is recommended to upload or select the appropriate sequencing vendor BED file'
                                        )}
                                      </span>
                                    </FormHelperText>
                                  </FormControl>
                                </Box>
                              </Grid>
                            )}

                            <Grid item xs={12} sm={6} lg={2.4}>
                              <Box
                                className={'flex items-center gap-2'}
                                alignItems="center"
                              >
                                <Typography
                                  className="font-medium"
                                  color="text.primary"
                                  sx={{
                                    wordBreak: 'keep-all',
                                    mr: 2
                                  }}
                                  flex={2}
                                  textAlign="right"
                                >
                                  {t('Infirmary Name')}:
                                </Typography>

                                <FormControl
                                  sx={{
                                    flex: 5
                                  }}
                                  fullWidth
                                >
                                  <Controller
                                    name="infirmaryName"
                                    control={Control}
                                    rules={{ required: true }}
                                    render={({
                                      field: { value, onChange }
                                    }) => (
                                      <TextField
                                        value={value}
                                        onChange={(e) => {
                                          onChange(e)
                                        }}
                                        size={'small'}
                                        placeholder={`${t(
                                          'Please enter the'
                                        )} ${t('infirmaryName')}`}
                                        error={Boolean(Errors.infirmaryName)}
                                      />
                                    )}
                                  />

                                  {Errors.infirmaryName && (
                                    <FormHelperText
                                      sx={{ color: 'error.main' }}
                                    >
                                      {Errors.infirmaryName.message}
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              </Box>
                            </Grid>

                            <Grid item xs={12} sm={6} lg={2.4}>
                              <Box
                                className={'flex items-center gap-2'}
                                alignItems="center"
                              >
                                <Typography
                                  className="font-medium"
                                  color="text.primary"
                                  sx={{
                                    wordBreak: 'keep-all',
                                    mr: 2
                                  }}
                                  flex={2}
                                  textAlign="right"
                                >
                                  {t('Sample Code')}:
                                </Typography>

                                <FormControl
                                  sx={{
                                    flex: 5
                                  }}
                                  fullWidth
                                >
                                  <Controller
                                    name="sampleCode"
                                    control={Control}
                                    rules={{ required: true }}
                                    render={({
                                      field: { value, onChange }
                                    }) => (
                                      <TextField
                                        value={value}
                                        onChange={(e) => {
                                          onChange(e)
                                        }}
                                        size={'small'}
                                        placeholder={`${t(
                                          'Please enter the'
                                        )} ${t('sampleCode')}`}
                                        error={Boolean(Errors.sampleCode)}
                                      />
                                    )}
                                  />

                                  {Errors.sampleCode && (
                                    <FormHelperText
                                      sx={{ color: 'error.main' }}
                                    >
                                      {Errors.sampleCode.message}
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              </Box>
                            </Grid>

                            <Grid item xs={12} sm={6} lg={2.4}>
                              <Box
                                className={'flex items-center gap-2'}
                                alignItems="center"
                              >
                                <Typography
                                  className="font-medium"
                                  color="text.primary"
                                  sx={{
                                    wordBreak: 'keep-all',
                                    mr: 2
                                  }}
                                  flex={2}
                                  textAlign="right"
                                >
                                  {t('Department Name')}:
                                </Typography>

                                <FormControl
                                  sx={{
                                    flex: 5
                                  }}
                                  fullWidth
                                >
                                  <Controller
                                    name="departmentName"
                                    control={Control}
                                    rules={{ required: true }}
                                    render={({
                                      field: { value, onChange }
                                    }) => (
                                      <TextField
                                        value={value}
                                        onChange={(e) => {
                                          onChange(e)
                                        }}
                                        size={'small'}
                                        placeholder={`${t(
                                          'Please enter the'
                                        )} ${t('departmentName')}`}
                                        error={Boolean(Errors.departmentName)}
                                      />
                                    )}
                                  />

                                  {Errors.departmentName && (
                                    <FormHelperText
                                      sx={{ color: 'error.main' }}
                                    >
                                      {Errors.departmentName.message}
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              </Box>
                            </Grid>

                            <Grid item xs={12} sm={6} lg={2.4}>
                              <Box
                                className={'flex items-center gap-2'}
                                alignItems="center"
                              >
                                <Typography
                                  className="font-medium"
                                  color="text.primary"
                                  sx={{
                                    wordBreak: 'keep-all',
                                    mr: 2
                                  }}
                                  flex={2}
                                  textAlign="right"
                                >
                                  {t('Physician Name')}:
                                </Typography>

                                <FormControl
                                  sx={{
                                    flex: 5
                                  }}
                                  fullWidth
                                >
                                  <Controller
                                    name="physicianName"
                                    control={Control}
                                    rules={{ required: true }}
                                    render={({
                                      field: { value, onChange }
                                    }) => (
                                      <TextField
                                        value={value}
                                        onChange={(e) => {
                                          onChange(e)
                                        }}
                                        size={'small'}
                                        placeholder={`${t(
                                          'Please enter the'
                                        )} ${t('physicianName')}`}
                                        error={Boolean(Errors.physicianName)}
                                      />
                                    )}
                                  />

                                  {Errors.physicianName && (
                                    <FormHelperText
                                      sx={{ color: 'error.main' }}
                                    >
                                      {Errors.physicianName.message}
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              </Box>
                            </Grid>

                            <Grid item xs={12} sm={6} lg={2.4}>
                              <Box
                                className={'flex items-center gap-2'}
                                alignItems="center"
                              >
                                <Typography
                                  className="font-medium"
                                  color="text.primary"
                                  sx={{
                                    wordBreak: 'keep-all',
                                    mr: 2
                                  }}
                                  flex={2}
                                  textAlign="right"
                                >
                                  {t('Family History')}:
                                </Typography>

                                <FormControl
                                  sx={{
                                    flex: 5
                                  }}
                                  fullWidth
                                >
                                  <Controller
                                    name="familyHistory"
                                    control={Control}
                                    rules={{ required: true }}
                                    render={({
                                      field: { value, onChange }
                                    }) => (
                                      <TextField
                                        value={value}
                                        onChange={(e) => {
                                          onChange(e)
                                        }}
                                        size={'small'}
                                        placeholder={`${t(
                                          'Please enter the'
                                        )} ${t('familyHistory')}`}
                                        error={Boolean(Errors.familyHistory)}
                                      />
                                    )}
                                  />

                                  {Errors.familyHistory && (
                                    <FormHelperText
                                      sx={{ color: 'error.main' }}
                                    >
                                      {Errors.familyHistory.message}
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              </Box>
                            </Grid>

                            <Grid item xs={12} sm={6} lg={2.4}>
                              <Box
                                className={'flex items-center gap-2'}
                                alignItems="center"
                              >
                                <Typography
                                  className="font-medium"
                                  color="text.primary"
                                  sx={{
                                    wordBreak: 'keep-all',
                                    mr: 2
                                  }}
                                  flex={2}
                                  textAlign="right"
                                >
                                  {t('Clinical Phenotype')}:
                                </Typography>

                                <FormControl
                                  sx={{
                                    flex: 5
                                  }}
                                  fullWidth
                                >
                                  <Controller
                                    name="phenotype"
                                    control={Control}
                                    rules={{ required: true }}
                                    render={({
                                      field: { value, onChange }
                                    }) => (
                                      <TextField
                                        value={value}
                                        onChange={(e) => {
                                          onChange(e)
                                        }}
                                        size={'small'}
                                        placeholder={`${t(
                                          'Please enter the'
                                        )} ${t('clinicalPhenotype')}`}
                                        error={Boolean(Errors.phenotype)}
                                      />
                                    )}
                                  />

                                  {Errors.phenotype && (
                                    <FormHelperText
                                      sx={{ color: 'error.main' }}
                                    >
                                      {Errors.phenotype.message}
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              </Box>
                            </Grid>

                            {props.analysisInfo &&
                            (props.analysisInfo.analysisType === 'big_family' ||
                              props.analysisInfo.analysisType ===
                                'family_analysis') ? (
                              <>
                                <Grid item xs={12} sm={6} lg={2.4}>
                                  <Box
                                    className={'flex items-center gap-2'}
                                    alignItems="center"
                                  >
                                    <Typography
                                      className="font-medium"
                                      color="text.primary"
                                      sx={{
                                        wordBreak: 'keep-all',
                                        mr: 2
                                      }}
                                      flex={2}
                                      textAlign="right"
                                    >
                                      {t('Affected or not')}:
                                    </Typography>

                                    <FormControl
                                      sx={{
                                        flex: 5
                                      }}
                                      fullWidth
                                    >
                                      <Controller
                                        name="isAffect"
                                        control={Control}
                                        rules={{ required: true }}
                                        render={({
                                          field: { value, onChange }
                                        }) => (
                                          <FormControlLabel
                                            control={
                                              <Switch
                                                checked={value}
                                                onChange={(e) => {
                                                  onChange(e)
                                                }}
                                              />
                                            }
                                            label={t('')}
                                          />
                                        )}
                                      />

                                      {Errors.isAffect && (
                                        <FormHelperText
                                          sx={{ color: 'error.main' }}
                                        >
                                          {Errors.isAffect.message}
                                        </FormHelperText>
                                      )}
                                    </FormControl>
                                  </Box>
                                </Grid>

                                {props.analysisInfo.analysisType ===
                                  'family_analysis' &&
                                props.analysisInfo?.samples?.length === 4 ? (
                                  <Grid item xs={12} sm={6} lg={2.4}>
                                    <Box
                                      className={'flex items-center gap-2'}
                                      alignItems="center"
                                    >
                                      <Typography
                                        className="font-medium"
                                        color="text.primary"
                                        sx={{
                                          wordBreak: 'keep-all',
                                          mr: 2
                                        }}
                                        flex={2}
                                        textAlign="right"
                                      >
                                        {t('ProBand or not')}:
                                      </Typography>

                                      <FormControl
                                        sx={{
                                          flex: 5
                                        }}
                                        fullWidth
                                      >
                                        <Controller
                                          name="isProBand"
                                          control={Control}
                                          rules={{ required: true }}
                                          render={({
                                            field: { value, onChange }
                                          }) => (
                                            <FormControlLabel
                                              control={
                                                <Switch
                                                  checked={value}
                                                  onChange={(e) => {
                                                    console.log(
                                                      e.target.checked
                                                    )

                                                    if (!e.target.checked) {
                                                      const analysisSamples =
                                                        props?.analysisData
                                                          ?.analysisSamples ??
                                                        []

                                                      if (analysisSamples) {
                                                        const flag =
                                                          analysisSamples.filter(
                                                            (i: any) =>
                                                              i.isProband
                                                          ).length

                                                        if (flag === 1) {
                                                          onChange(e)

                                                          messageApi.warning(
                                                            t(
                                                              'Please keep at least one proband!'
                                                            )
                                                          )
                                                        } else {
                                                          onChange(e)
                                                        }
                                                      } else onChange(e)
                                                    } else onChange(e)
                                                  }}
                                                />
                                              }
                                              label={t('')}
                                            />
                                          )}
                                        />

                                        {Errors.isProBand && (
                                          <FormHelperText
                                            sx={{ color: 'error.main' }}
                                          >
                                            {Errors.isProBand.message}
                                          </FormHelperText>
                                        )}
                                      </FormControl>
                                    </Box>
                                  </Grid>
                                ) : (
                                  ''
                                )}
                              </>
                            ) : (
                              ''
                            )}

                            {props.analysisInfo &&
                            props.analysisInfo.sampleType === 'vcf' ? (
                              <Grid item xs={12} sm={6}>
                                <Stack spacing={4} direction="row">
                                  <Box flex={1}>
                                    <Button
                                      variant="contained"
                                      component="label"
                                    >
                                      <input
                                        onChange={handleSvFileChange}
                                        type="file"
                                        hidden
                                        accept=".sv.vcf, .sv.vcf.gz"
                                      />
                                      sv {t('upload')}
                                    </Button>

                                    <Box>
                                      {sampleField.patient.hasSv ? (
                                        <Typography>
                                          {sampleField.patient.svName}

                                          <IconButton
                                            onClick={() => {
                                              const params = {
                                                ...sampleField.patient,
                                                svName: '',
                                                svFile: '',
                                                hasSv: false
                                              }

                                              setSampleField({
                                                patient: params
                                              })

                                              setSvProcess(0)

                                              const params2 = {
                                                ...samples,
                                                hasSv: 0,
                                                svFile: '',
                                                hasCnv: sampleField.patient
                                                  .hasCnv
                                                  ? 1
                                                  : 0,
                                                terms: isJson(
                                                  samples?.terms as string
                                                )
                                                  ? samples?.terms
                                                  : JSON.stringify(
                                                      samples?.terms
                                                    )
                                              }

                                              editSamples.mutateAsync(
                                                params2 as any
                                              )

                                              messageRef?.current?.handleClick(
                                                t('Upload successful'),
                                                'success'
                                              )
                                            }}
                                          >
                                            <Close
                                              sx={{ fontSize: '1.125rem' }}
                                            />
                                          </IconButton>
                                        </Typography>
                                      ) : (
                                        <Typography>
                                          {t('Not uploaded')}
                                        </Typography>
                                      )}
                                    </Box>

                                    <LinearProgressWithLabel
                                      value={svProcess}
                                    />
                                  </Box>

                                  <Box flex={1}>
                                    <Button
                                      variant="contained"
                                      component="label"
                                    >
                                      <input
                                        onChange={handleCnvFileChange}
                                        type="file"
                                        hidden
                                        accept=".exoncnv.vcf,.cnv.vcf, .cnv.vcf.gz,.call.cns"
                                      />
                                      cnv {t('upload')}
                                    </Button>

                                    <Box>
                                      {sampleField.patient.hasCnv ? (
                                        <Typography>
                                          {sampleField.patient.cnvName}

                                          <IconButton
                                            onClick={() => {
                                              const params = {
                                                ...sampleField.patient,
                                                cnvName: '',
                                                cnvFile: '',
                                                hasCnv: false
                                              }

                                              setSampleField({
                                                patient: params
                                              })

                                              const params2 = {
                                                ...samples,
                                                hasCnv: 0,
                                                cnvFile: '',
                                                hasSv: sampleField.patient.hasSv
                                                  ? 1
                                                  : 0,
                                                terms: isJson(
                                                  samples?.terms as string
                                                )
                                                  ? samples?.terms
                                                  : JSON.stringify(
                                                      samples?.terms
                                                    )
                                              }

                                              editSamples.mutateAsync(
                                                params2 as any
                                              )

                                              messageRef?.current?.handleClick(
                                                t('Upload successful'),
                                                'success'
                                              )

                                              setCnvProcess(0)
                                            }}
                                          >
                                            <Close
                                              sx={{ fontSize: '1.125rem' }}
                                            />
                                          </IconButton>
                                        </Typography>
                                      ) : (
                                        <Typography>
                                          {t('Not uploaded')}
                                        </Typography>
                                      )}
                                    </Box>

                                    <LinearProgressWithLabel
                                      value={cnvProcess}
                                    />
                                  </Box>
                                </Stack>
                              </Grid>
                            ) : props.analysisInfo &&
                              props.analysisInfo.sampleType === 'fastq' ? (
                              <Grid item xs={12} sm={6} lg={3}>
                                {/* <Stack spacing={4} direction="row">
                                  <Box flex={1}>
                                    <Button
                                      variant="contained"
                                      component="label"
                                    >
                                      <input
                                        onChange={handleFqFileChange}
                                        type="file"
                                        hidden
                                        accept=".fastq.gz, .fq.gz"
                                      />
                                      Fastq{t('upload')}
                                    </Button>

                                    <Box>
                                      {sampleField.patient.fqFiles &&
                                      sampleField.patient.fqFiles.length ? (
                                        <Box>
                                          {sampleField.patient.fqFiles.map(
                                            (items) => {
                                              return (
                                                <Box
                                                  key={`${items.fileName}_${items.process}`}
                                                >
                                                  <Typography>
                                                    {items.fileName}

                                                    <IconButton
                                                      onClick={async () => {
                                                        const params = {
                                                          ...sampleField.patient,
                                                          fqFiles:
                                                            sampleField.patient.fqFiles.filter(
                                                              (item) =>
                                                                item.fileName !==
                                                                items.fileName
                                                            )
                                                        }

                                                        //

                                                        setSampleField({
                                                          patient: params
                                                        })

                                                        const flag =
                                                          abortCheckpoint.find(
                                                            (item) =>
                                                              item.name ===
                                                              `fastq_uploads/${items.fileName}`
                                                          )

                                                        console.log(
                                                          flag,
                                                          client
                                                        )

                                                        if (
                                                          flag &&
                                                          items.process !== 100
                                                        ) {
                                                          await client?.abortMultipartUpload(
                                                            flag?.name,
                                                            flag?.uploadId
                                                          )
                                                        }
                                                      }}
                                                    >
                                                      <Close
                                                        sx={{
                                                          fontSize: '1.125rem'
                                                        }}
                                                      />
                                                    </IconButton>
                                                  </Typography>

                                                  <LinearProgressWithLabel
                                                    value={items.process ?? 0}
                                                  />
                                                </Box>
                                              )
                                            }
                                          )}
                                        </Box>
                                      ) : (
                                        <Typography>
                                          {t('Not uploaded')}
                                        </Typography>
                                      )}
                                    </Box>
                                  </Box>
                                </Stack> */}
                              </Grid>
                            ) : (
                              ''
                            )}

                            <Grid item xs={12}>
                              <Button
                                variant="contained"
                                startIcon={<ContentSave />}
                                type="submit"
                              >
                                {t('save')}
                              </Button>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                          <Box
                            sx={{
                              height: '100%',
                              border: '1px solid',
                              borderColor: 'divider',
                              borderRadius: 3,
                              backgroundColor: 'rgba(15, 23, 42, 0.015)',
                              p: 2.5
                            }}
                          >
                            <Grid
                              container
                              sx={{
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: 1.5
                              }}
                            >
                              <Grid item>
                                <SectionHeader>
                                  {t('Clinical information')}:
                                </SectionHeader>
                              </Grid>
                            </Grid>

                            <TextField
                              fullWidth
                              id="outlined-multiline-flexible"
                              multiline
                              maxRows={10}
                              minRows={4}
                              value={clinicalInformation}
                              onChange={(e) =>
                                setClinicalInformation(e.target.value)
                              }
                              placeholder={t(
                                'Please enter and click the Apply button in the bottom right corner'
                              )}
                              sx={{
                                '& .MuiOutlinedInput-root': {
                                  borderRadius: 2,
                                  backgroundColor: '#fff',
                                  '& fieldset': {
                                    borderColor: 'rgba(15, 23, 42, 0.12)'
                                  },
                                  '&:hover fieldset': {
                                    borderColor: 'primary.main'
                                  }
                                },
                                '& .MuiInputBase-input': {
                                  fontSize: 14,
                                  lineHeight: 1.6,
                                  '::placeholder': {
                                    color: 'red'
                                  }
                                }
                              }}
                            />

                            <Stack
                              direction={'row'}
                              spacing={2}
                              mt={2.5}
                              justifyContent="end"
                            >
                              <Button
                                variant="contained"
                                startIcon={
                                  backop ? (
                                    <CircularProgress size="20px" />
                                  ) : (
                                    <PlusCircleOutline />
                                  )
                                }
                                onClick={async () => {
                                  await getHpoAndTerms()
                                }}
                                disabled={backop}
                                sx={{
                                  borderRadius: 2,
                                  boxShadow: 'none',
                                  px: 2.25,
                                  py: 1
                                }}
                              >
                                {t('One-click generation of phenotypes')}
                              </Button>
                            </Stack>

                            <Box
                              maxHeight={200}
                              overflow="auto"
                              mt={2}
                              sx={{
                                border: '1px solid',
                                borderColor: 'rgba(15, 23, 42, 0.08)',
                                backgroundColor: '#fff',
                                borderRadius: 2,
                                p: 1.5
                              }}
                            >
                              {ChatQwen.map((item) => (
                                <Stack
                                  direction={'row'}
                                  alignItems="center"
                                  justifyContent="space-between"
                                  key={`${item.hpo_code}-${item.name_en}`}
                                >
                                  <Typography
                                    color={'primary.main'}
                                    py={0.75}
                                    sx={{ fontWeight: 500, fontSize: 14 }}
                                  >
                                    {`${item.hpo_code}(${
                                      i18n.language === 'zh'
                                        ? item.name_cn
                                        : item.name_en
                                    })`}
                                  </Typography>
                                </Stack>
                              ))}
                            </Box>
                          </Box>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <Box
                            sx={{
                              height: '100%',
                              border: '1px solid',
                              borderColor: 'divider',
                              borderRadius: 3,
                              backgroundColor: 'rgba(15, 23, 42, 0.015)',
                              p: 2.5
                            }}
                          >
                            <Grid
                              container
                              sx={{
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: 1.5
                              }}
                            >
                              <Grid item>
                                <SectionHeader>{t('Term list')}</SectionHeader>
                              </Grid>
                            </Grid>

                            <Stack spacing={2.5} mb={1}>
                              <ChinahpoSearch
                                termList={termList}
                                fn={(query: any) => {
                                  setTermList(query)

                                  return query
                                }}
                                sx={{
                                  flex: 1,
                                  width: '100%',
                                  '& .MuiInputBase-root': {
                                    alignItems: 'flex-start',
                                    borderRadius: 2,
                                    backgroundColor: '#fff'
                                  },
                                  '& .MuiInputBase-input': {
                                    '::placeholder': {
                                      color: 'red'
                                    }
                                  }
                                }}
                                type={'patient'}
                              />

                              <Stack
                                direction={'row'}
                                spacing={2}
                                textAlign={'right'}
                                mb={1}
                                justifyContent={'flex-end'}
                              >
                                <Button
                                  variant="contained"
                                  startIcon={<ContentSave />}
                                  onClick={saveClinical}
                                  sx={{
                                    borderRadius: 2,
                                    boxShadow: 'none',
                                    px: 2.25,
                                    py: 1
                                  }}
                                >
                                  {t('save')}
                                </Button>

                                <Button
                                  variant="contained"
                                  startIcon={<ContentCopy />}
                                  onClick={(e) => {
                                    if (termList.length > 0) {
                                      copyToClipboard(
                                        termList
                                          .map((item) =>
                                            item.hpo_code
                                              ? `${item.hpo_code}(${
                                                  i18n.language === 'zh'
                                                    ? item.name_cn
                                                    : item.name_en
                                                })`
                                              : `${
                                                  i18n.language === 'zh'
                                                    ? `${item.name_en}(${item.name_cn})`
                                                    : item.name_en
                                                }`
                                          )
                                          .join(
                                            i18n.language === 'zh' ? '，' : ','
                                          ),
                                        e
                                      )

                                      messageApi.success(
                                        i18n.language === 'zh'
                                          ? '复制成功'
                                          : 'Copy success'
                                      )
                                    }
                                  }}
                                  sx={{
                                    borderRadius: 2,
                                    boxShadow: 'none',
                                    px: 2.25,
                                    py: 1
                                  }}
                                >
                                  {t('Copy')}
                                </Button>
                              </Stack>
                            </Stack>
                          </Box>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </form>
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* <PasteHtmlExample value={[]} /> */}
        <RolDialog
          rolToEdit={null}
          open={openRol}
          onClose={() => {
            setOpenRol(false)
          }}
          onSave={handleSaveGeneSets}
        />

        <PositionedSnackbar ref={messageRef} />

        <BootstrapDialog
          onClose={() => setImgOpen(!imgOpen)}
          aria-labelledby="customized-dialog-title"
          open={imgOpen}
          TransitionComponent={Transition}
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
            {`${t('Case picture')}`}
          </DialogTitle>

          <IconButton
            aria-label="close"
            onClick={() => setImgOpen(!imgOpen)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500]
            }}
          >
            <CloseIcon />
          </IconButton>

          <DialogContent dividers>
            <Box>
              <img src={imgSrc.src} />
            </Box>
          </DialogContent>

          <DialogActions>
            <Stack direction="row" spacing={4} padding={'10px 0'}>
              <Button
                variant="outlined"
                size="small"
                autoFocus
                onClick={() => setImgOpen(!imgOpen)}
              >
                {t('close')}
              </Button>
            </Stack>
          </DialogActions>
        </BootstrapDialog>

        {/* <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={backop}
          id="backdrop"
        >
          <CircularProgress color="inherit" />
        </Backdrop> */}
      </Box>
    )
  }
)
export default PatientInformation
